import { AnyAction } from '@reduxjs/toolkit'
import { get, mapValues } from 'lodash'

import { FETCH_CONSOLE_CONFIGURATION_SUCCESS, FETCH_TENANT_CONFIGURATION_SUCCESS } from '@/components/App/actionTypes'

type ConfigurationState = {
  apiHost: string | null
  clientId: string | null
  authorizeUrl: string | null
  cognito: { userPoolId: string | null }
  companyName: string
  features: Record<string, string | number | boolean>
}

const initialState: ConfigurationState = {
  apiHost: null,
  clientId: null,
  authorizeUrl: null,
  cognito: { userPoolId: null },
  companyName: '',
  features: {}
}

export default function configurationReducer(state = initialState, action: AnyAction): ConfigurationState {
  switch (action.type) {
    case FETCH_CONSOLE_CONFIGURATION_SUCCESS: {
      const flags = get(action, 'response', {})
      return {
        ...state,
        features: {
          ...state.features,
          // Flatten the structure so that it's just a map of key/value pairs that aligns with LaunchDarkly SDKs
          ...mapValues(flags, 'value')
        }
      }
    }

    case FETCH_TENANT_CONFIGURATION_SUCCESS: {
      const client = action.response.clients.console

      // this should ALWAYS be the first request to fire in the Console
      return {
        ...initialState,
        apiHost: action.response.apiHost,
        clientId: action.isAdminLogin ? client.adminClientId : client.clientId,
        authorizeUrl: action.response.openidConfiguration.authorization_endpoint,
        companyName: action.response.companyName || '',
        cognito: { userPoolId: action.response.cognito.userPools[0].userPoolId }
      }
    }

    default: {
      return state
    }
  }
}
